import React from 'react';
import { Switch } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';
import { FieldInfoMessage } from './FieldInfoMessage';

export const SwitchField = ({ name, label, disabled, infoMessage, required }: any) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const handleToggle = (checked: boolean) => {
    setFieldValue(name, checked); // Update the field value
  };

  return (
    <FormFieldWrapper name={name} label={""} required={required}><br/>
      <div className="flex items-center space-x-2">
        <Switch
          checked={values[name]}
          onChange={handleToggle}
          disabled={disabled}
        />
        <span>{label}
        {required && <span className="text-red-500 ml-1">*</span>}
        </span>
      </div>
      {infoMessage && <FieldInfoMessage message={infoMessage} />}
    </FormFieldWrapper>
  );
};
